import { render, staticRenderFns } from "./AvatarView.vue?vue&type=template&id=372318e2&"
import script from "./AvatarView.vue?vue&type=script&lang=js&"
export * from "./AvatarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports